// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/weather_forecast_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { AreaWeatherForecast } from "./weather_forecast_model_pb";
import { file_bffuser_v1_weather_forecast_model } from "./weather_forecast_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/weather_forecast_service.proto.
 */
export const file_bffuser_v1_weather_forecast_service: GenFile = /*@__PURE__*/
  fileDesc("CiliZmZ1c2VyL3YxL3dlYXRoZXJfZm9yZWNhc3Rfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSK9AQodR2V0QXJlYVdlYXRoZXJGb3JlY2FzdFJlcXVlc3QSNAoJYXJlYV9jb2RlGAEgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGVCCrpIB4IBBBABIAASMwoQdGFyZ2V0X2RhdGVfZnJvbRgCIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBARIxCg50YXJnZXRfZGF0ZV90bxgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBASJTCh5HZXRBcmVhV2VhdGhlckZvcmVjYXN0UmVzcG9uc2USMQoIZm9yZWNhc3QYASABKAsyHy5iZmZ1c2VyLnYxLkFyZWFXZWF0aGVyRm9yZWNhc3QizwEKI0JhdGNoR2V0QXJlYVdlYXRoZXJGb3JlY2FzdHNSZXF1ZXN0EkAKCmFyZWFfY29kZXMYASADKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIVukgSkgEPCAEQChgBIgeCAQQQASAAEjMKEHRhcmdldF9kYXRlX2Zyb20YAiABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQESMQoOdGFyZ2V0X2RhdGVfdG8YAyABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQEiWgokQmF0Y2hHZXRBcmVhV2VhdGhlckZvcmVjYXN0c1Jlc3BvbnNlEjIKCWZvcmVjYXN0cxgBIAMoCzIfLmJmZnVzZXIudjEuQXJlYVdlYXRoZXJGb3JlY2FzdDKRAgoWV2VhdGhlckZvcmVjYXN0U2VydmljZRJxChZHZXRBcmVhV2VhdGhlckZvcmVjYXN0EikuYmZmdXNlci52MS5HZXRBcmVhV2VhdGhlckZvcmVjYXN0UmVxdWVzdBoqLmJmZnVzZXIudjEuR2V0QXJlYVdlYXRoZXJGb3JlY2FzdFJlc3BvbnNlIgASgwEKHEJhdGNoR2V0QXJlYVdlYXRoZXJGb3JlY2FzdHMSLy5iZmZ1c2VyLnYxLkJhdGNoR2V0QXJlYVdlYXRoZXJGb3JlY2FzdHNSZXF1ZXN0GjAuYmZmdXNlci52MS5CYXRjaEdldEFyZWFXZWF0aGVyRm9yZWNhc3RzUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bffuser_v1_weather_forecast_model, file_buf_validate_validate, file_google_type_date]);

/**
 * GetAreaWeatherForecastRequest carries the area and inclusive target-date
 * range.
 *
 * @generated from message bffuser.v1.GetAreaWeatherForecastRequest
 */
export type GetAreaWeatherForecastRequest = Message<"bffuser.v1.GetAreaWeatherForecastRequest"> & {
  /**
   * Target electricity area. UNSPECIFIED is rejected.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Inclusive start of the target-date range.
   *
   * @generated from field: google.type.Date target_date_from = 2;
   */
  targetDateFrom?: Date;

  /**
   * Inclusive end of the target-date range. Must be >= target_date_from.
   *
   * @generated from field: google.type.Date target_date_to = 3;
   */
  targetDateTo?: Date;
};

/**
 * Describes the message bffuser.v1.GetAreaWeatherForecastRequest.
 * Use `create(GetAreaWeatherForecastRequestSchema)` to create a new message.
 */
export const GetAreaWeatherForecastRequestSchema: GenMessage<GetAreaWeatherForecastRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_service, 0);

/**
 * @generated from message bffuser.v1.GetAreaWeatherForecastResponse
 */
export type GetAreaWeatherForecastResponse = Message<"bffuser.v1.GetAreaWeatherForecastResponse"> & {
  /**
   * @generated from field: bffuser.v1.AreaWeatherForecast forecast = 1;
   */
  forecast?: AreaWeatherForecast;
};

/**
 * Describes the message bffuser.v1.GetAreaWeatherForecastResponse.
 * Use `create(GetAreaWeatherForecastResponseSchema)` to create a new message.
 */
export const GetAreaWeatherForecastResponseSchema: GenMessage<GetAreaWeatherForecastResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_service, 1);

/**
 * BatchGetAreaWeatherForecastsRequest carries the areas and the inclusive target-date range
 * shared by every area.
 *
 * @generated from message bffuser.v1.BatchGetAreaWeatherForecastsRequest
 */
export type BatchGetAreaWeatherForecastsRequest = Message<"bffuser.v1.BatchGetAreaWeatherForecastsRequest"> & {
  /**
   * Target electricity areas (1 to 10, no duplicates). UNSPECIFIED is
   * rejected.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 1;
   */
  areaCodes: AreaCode[];

  /**
   * Inclusive start of the target-date range.
   *
   * @generated from field: google.type.Date target_date_from = 2;
   */
  targetDateFrom?: Date;

  /**
   * Inclusive end of the target-date range. Must be >= target_date_from.
   *
   * @generated from field: google.type.Date target_date_to = 3;
   */
  targetDateTo?: Date;
};

/**
 * Describes the message bffuser.v1.BatchGetAreaWeatherForecastsRequest.
 * Use `create(BatchGetAreaWeatherForecastsRequestSchema)` to create a new message.
 */
export const BatchGetAreaWeatherForecastsRequestSchema: GenMessage<BatchGetAreaWeatherForecastsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_service, 2);

/**
 * @generated from message bffuser.v1.BatchGetAreaWeatherForecastsResponse
 */
export type BatchGetAreaWeatherForecastsResponse = Message<"bffuser.v1.BatchGetAreaWeatherForecastsResponse"> & {
  /**
   * One element per requested area, in request order.
   *
   * @generated from field: repeated bffuser.v1.AreaWeatherForecast forecasts = 1;
   */
  forecasts: AreaWeatherForecast[];
};

/**
 * Describes the message bffuser.v1.BatchGetAreaWeatherForecastsResponse.
 * Use `create(BatchGetAreaWeatherForecastsResponseSchema)` to create a new message.
 */
export const BatchGetAreaWeatherForecastsResponseSchema: GenMessage<BatchGetAreaWeatherForecastsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_service, 3);

/**
 * WeatherForecastService provides live JMA weather forecasts (sourced from
 * BigQuery) for the generation/consumption planning screens.
 *
 * @generated from service bffuser.v1.WeatherForecastService
 */
export const WeatherForecastService: GenService<{
  /**
   * GetAreaWeatherForecast returns the 8-metric forecast bundle for the area
   * and target-date range. organization_id is resolved by the BFF handler
   * from eauth.
   *
   * @generated from rpc bffuser.v1.WeatherForecastService.GetAreaWeatherForecast
   */
  getAreaWeatherForecast: {
    methodKind: "unary";
    input: typeof GetAreaWeatherForecastRequestSchema;
    output: typeof GetAreaWeatherForecastResponseSchema;
  },
  /**
   * BatchGetAreaWeatherForecasts returns one forecast per requested area, in request order
   * (area_code identifies each element), for the shared target-date range.
   * organization_id is resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.WeatherForecastService.BatchGetAreaWeatherForecasts
   */
  batchGetAreaWeatherForecasts: {
    methodKind: "unary";
    input: typeof BatchGetAreaWeatherForecastsRequestSchema;
    output: typeof BatchGetAreaWeatherForecastsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_weather_forecast_service, 0);

